import React from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { Checkbox, MenuItem, Select, Tooltip } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { SelectItem } from '../types/locationTypes'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

interface PlannerMultipleSelectProps {
    parentClasses: ClassNameMap,
    listValues: SelectItem[],
    setValue: any,
    value: string,
    labelText: string,
    lastElement?: boolean,
    description: string,
    readonly:boolean,
}

const PlannerMultipleSelect: React.FC<PlannerMultipleSelectProps> = ({
    parentClasses,
    listValues,
    setValue,
    value,
    labelText,
    lastElement,
    description,
    readonly
}) => {
    const values = value ? value.split(',') : [];

    const handleChange = (event: any) => {
        const newValues = event.target.value;
        setValue(
            newValues.join(',')
        );
    };

    return (
        <div className={parentClasses.inputRow} style={lastElement ? {
            borderBottomRightRadius: 4
        } : {}}>
            <div className={parentClasses.labelText}>
                {labelText}
                <span>
                    <Tooltip title={description}>
                        <InfoOutlinedIcon className={parentClasses.labelIcon} />
                    </Tooltip>
                </span>
            </div>
            <Select
                onChange={handleChange}
                className={parentClasses.selectField}
                multiple
                fullWidth={true}
                value={values}
                IconComponent={KeyboardArrowDownIcon}
                displayEmpty
                renderValue={(selected: any) => selected?.join(', ')}
                disabled={readonly}
                variant="outlined">
                {
                    listValues.map(
                        item =>
                            <MenuItem
                                disabled={item.disabled}
                                selected={item.selected}
                                key={item.value}
                                defaultValue={item.value}
                                value={item.value}>
                                <Checkbox checked={values.indexOf(item.value ?? '') > -1} />
                                {item.text}
                            </MenuItem>
                    )
                }
            </Select>
        </div>
    );
}

export default PlannerMultipleSelect;